/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  svgStyle?:{};
  color?: string;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24, svgStyle, color }) => (
  <svg
    width={width}
    height={height}
    style={svgStyle}
    viewBox="0 0 24 24"
    fill={color ? color:"#262626"}
    xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 17.25C12.7167 17.25 12.896 17.1793 13.038 17.038C13.1793 16.896 13.25 16.7167 13.25 16.5V12.225C13.25 12.025 13.1793 11.854 13.038 11.712C12.896 11.5707 12.7167 11.5 12.5 11.5C12.2833 11.5 12.1043 11.5707 11.963 11.712C11.821 11.854 11.75 12.0333 11.75 12.25V16.525C11.75 16.725 11.821 16.896 11.963 17.038C12.1043 17.1793 12.2833 17.25 12.5 17.25ZM12.5 9.8C12.7333 9.8 12.925 9.72067 13.075 9.562C13.225 9.404 13.3 9.20833 13.3 8.975C13.3 8.75833 13.225 8.57067 13.075 8.412C12.925 8.254 12.7333 8.175 12.5 8.175C12.2667 8.175 12.075 8.254 11.925 8.412C11.775 8.57067 11.7 8.75833 11.7 8.975C11.7 9.20833 11.775 9.404 11.925 9.562C12.075 9.72067 12.2667 9.8 12.5 9.8ZM12.5 22C11.1833 22 9.946 21.75 8.788 21.25C7.62933 20.75 6.625 20.075 5.775 19.225C4.925 18.375 4.25 17.3707 3.75 16.212C3.25 15.054 3 13.8167 3 12.5C3 11.1833 3.25 9.94567 3.75 8.787C4.25 7.629 4.925 6.625 5.775 5.775C6.625 4.925 7.62933 4.25 8.788 3.75C9.946 3.25 11.1833 3 12.5 3C13.8167 3 15.0543 3.25 16.213 3.75C17.371 4.25 18.375 4.925 19.225 5.775C20.075 6.625 20.75 7.629 21.25 8.787C21.75 9.94567 22 11.1833 22 12.5C22 13.8167 21.75 15.054 21.25 16.212C20.75 17.3707 20.075 18.375 19.225 19.225C18.375 20.075 17.371 20.75 16.213 21.25C15.0543 21.75 13.8167 22 12.5 22ZM12.5 20.5C14.7167 20.5 16.6043 19.721 18.163 18.163C19.721 16.6043 20.5 14.7167 20.5 12.5C20.5 10.2833 19.721 8.39567 18.163 6.837C16.6043 5.279 14.7167 4.5 12.5 4.5C10.2833 4.5 8.396 5.279 6.838 6.837C5.27933 8.39567 4.5 10.2833 4.5 12.5C4.5 14.7167 5.27933 16.6043 6.838 18.163C8.396 19.721 10.2833 20.5 12.5 20.5Z" />
  </svg>
);


export default SvgComponent;
